import React from 'react';
import videoFile7 from './777sized.mp4';



const MyVideoComponent8 = () => {
    return (
     
        <div >
            <video controls>
                <source src={videoFile7} />
            </video>
        </div>
    );
};

export default MyVideoComponent8;

